(function(){
    'use strict';

    angular
    .module('appback')
    .controller('CarriersController', CarriersController)
 
    CarriersController.$inject = ["CuentaService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function CarriersController(CuentaService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this; 
        vm.modalInstance = "";
        console.log("carriers");
        vm.showModal = function(type,id){
            CuentaService.getCuentaCarrier(type,id).then(function(data){
                vm.modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: '/backend/app/views/carrier.html',
                    controller: function($scope) {
                        $scope.info = data.data;
                        $scope.koForm = function(){
                            vm.modalInstance.close();
                        }
                    },
                    size: 'lg',
                });
            })
                
        }
	}
  
})();